import { twMerge } from '@stereoagency/tailwind-config';
import React from 'react';
import { useAccentColors } from '../../hooks';
import { Button, EntryAnimation } from '../../atoms';
var letters = Array.from('ABCDEFGHIJKLMNOPQRSTUVWXYZ');
export default function AlphabeticalGridFilter(param) {
    var resetAction = param.resetAction, value = param.value, include = param.include, _param_accentColor = param.accentColor, accentColor = _param_accentColor === void 0 ? '--colors-red-700' : _param_accentColor, onChange = param.onChange, className = param.className;
    var accentStyle = useAccentColors([
        'colors-alphabetical-grid-filter-bg-selected',
        accentColor
    ], [
        'colors-button-secondary-bg-base',
        '--colors-bg-subtle'
    ], [
        'colors-button-secondary-bg-hover',
        '--colors-subtle-700'
    ]);
    var handleReset = function handleReset() {
        onChange === null || onChange === void 0 ? void 0 : onChange(null);
    };
    return /*#__PURE__*/ React.createElement("div", {
        style: accentStyle,
        className: twMerge('flex justify-start', className)
    }, /*#__PURE__*/ React.createElement(EntryAnimation, null, resetAction && /*#__PURE__*/ React.createElement(Button, {
        variant: "secondary",
        className: twMerge('mb-5 flex justify-start items-center', !value && 'text-fg-inverted bg-[var(--colors-alphabetical-grid-filter-bg-selected)] border-[var(--colors-alphabetical-grid-filter-bg-selected)] hover:bg-[var(--colors-alphabetical-grid-filter-bg-selected)] hover:border-[var(--colors-alphabetical-grid-filter-bg-selected)]'),
        onClick: handleReset
    }, /*#__PURE__*/ React.createElement("span", null, resetAction.label), !!resetAction.suffix && /*#__PURE__*/ React.createElement("span", {
        className: "ml-3 font-normal text-navigation-small"
    }, resetAction.suffix)), /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-4 grid-cols-6 grid-flow-row auto-rows-max"
    }, letters.map(function(letter) {
        if ((include === null || include === void 0 ? void 0 : include.length) && !include.includes(letter)) return null;
        return /*#__PURE__*/ React.createElement("button", {
            type: "button",
            key: letter,
            className: twMerge('text-button-base font-heading font-bold w-[2.25rem] h-[2.25rem] rounded-full bg-bg-subtle hover:bg-subtle-700', letter === value && 'bg-[var(--colors-alphabetical-grid-filter-bg-selected)] text-fg-inverted'),
            onClick: function onClick() {
                return onChange === null || onChange === void 0 ? void 0 : onChange(letter);
            }
        }, letter);
    }))));
}

//# sourceMappingURL=AlphabeticalGridFilter.js.map